//import * as Sentry from '@sentry/browser';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, ErrorHandler, Injectable } from '@angular/core';

import { AppComponent } from '@app/app.component';
import { AppRoutingModule } from '@app/app-routing.module';
import { CoreModule } from '@core/core.module';
import { registerLocaleData } from '@angular/common';
import { environment } from '@environments/environment';
import localeEs from '@angular/common/locales/es';
// import { CookieService } from 'ngx-cookie-service';
// import { CookieService } from 'ngx-cookie-service/cookie-service/cookie.service';
// import { CookieService } from './packages/ngx-cookie-service/cookie-service/cookie.service';

registerLocaleData(localeEs, 'es');

let providers = [];

/*
if (environment.SENTRY_URL) {
  Sentry.init({
    dsn: environment.SENTRY_URL,
    release: environment.RELEASE_VERSION
  });

  @Injectable()
  class SentryErrorHandler implements ErrorHandler {
    constructor() { }
    handleError(error) {
      const eventId = Sentry.captureException(error.originalError || error);
      Sentry.showReportDialog({ eventId });
    }
  }
 
  providers.push({
    provide: ErrorHandler,
    useClass: SentryErrorHandler
  });
}
*/
@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, AppRoutingModule, CoreModule],
  providers: [{ provide: LOCALE_ID, useValue: 'es' }, ...providers],
  bootstrap: [AppComponent]
})
export class AppModule { }
